import React, { useState } from 'react';
import { withRouter } from "react-router-dom";

import {
  Nav, NavLink, NavItem, TabPane, Container,
} from 'reactstrap';
import { connect } from 'react-redux';

import Transportation from '../../../SingleBuilding/components/Environment/transportation';
import Schools from '../../../SingleBuilding/components/Environment/schools';
import Flood from '../../../SingleBuilding/components/Environment/flood';

import { Publisher } from '../../../../shared/pubsub/publisher.js';

import classnames from 'classnames';
import{
	_getBuildingURL,
	_nameToUrl
} from '../../../../shared/helpers/utils';

const Area = (props) => {
	const { buildingRes } = props;
	const unit = props.match && props.match.params.unit ? props.match.params.unit : '';
	const defaultTab = props.match && props.match.params.subtab ? props.match.params.subtab : 'transportation';
	const [activeTab, setActiveTab] = useState(defaultTab);

	const _toggleTab = (tab) => {
		if (activeTab !== tab) {
		  const buildingURL = _getBuildingURL(buildingRes, 'building_slugs') + '/' + _nameToUrl(unit) + (tab ? `/tab/area/${tab}` : '');
		  window.history && window.history.pushState({}, null, buildingURL);
		  setActiveTab(tab);
		  Publisher.publish(`track.unitAreaView.${tab}`, {building: buildingRes.key, unit: unit});
		}
	};

	return(
		<div>
		<Container className="dashboard" style={{ "border" : "0px solid #DBE0E8" }}>
			<div className="tabs">
			<div className="tabs__wrap mb-2">
				<Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: activeTab === 'transportation' })}
					  onClick={() => _toggleTab('transportation')}
					>
					  <span className="tab-title">Transportation</span>
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: activeTab === 'schools' })}
					  onClick={() => _toggleTab('schools')}
					>
					  <span className="tab-title">Schools</span>
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: activeTab === 'flood' })}
					  onClick={() => _toggleTab('flood')}
					>
					  <span className="tab-title">Flood</span>
					</NavLink>
				  </NavItem>
				</Nav>
			  </div>
			</div>
		</Container>
		{activeTab === 'transportation' &&
		  <TabPane tabId="transportation">
			 <Transportation {...props} />
		  </TabPane>
		}
		{activeTab === 'schools' &&
		  <TabPane tabId="schools">
			 <Schools {...props} />
		  </TabPane>
		}
		{activeTab === 'flood' &&
		  <TabPane tabId="flood">
			 <Flood {...props} />
		  </TabPane>
		}
		</div>
	)
};

export default connect(state => ({
  user: state.user,
}))(withRouter(Area));
